import './App.css';
import LinksSection from './components/LinksSection/LinksSection';
import Section from './components/Section/Section';
import Skills from './components/Skills/Skills';
import Company from './components/Company/Company';
import School from './components/School/School';
import Project from './components/Project/Project';
import starbourne from './data/companies/starbourne';
import airhouse from './data/companies/airhouse';
import jwg from './data/companies/jwg';
import lvr from './data/companies/lvr';
import realTimeVoiceCoach from './data/projects/real-time-voice-coach';
import tradeJournalTracker from './data/projects/trade-journal-tracker';
import skills from './data/skills';
import unlv from './data/education/unlv';


function App() {
  return (
    <div className="App">
      <header>
        <h1>Spencer Franklin</h1>
        <LinksSection />
      </header>

      <main>
        <Section name="Work Experience" />
        <Company {...starbourne} />
        <Company {...airhouse} />
        <Company {...jwg} />
        <Company {...lvr} />

        <Section name="Projects" />
        <Project {...realTimeVoiceCoach} />
        <Project {...tradeJournalTracker} />

        <Section name="Technical Skills" />
        <Skills skills={skills} />

        <Section name="Education" />
        <School {...unlv} />
      </main>
    </div>
  );
}

export default App;
